/**
 * Вызовите `registerShefaLoaderProgress` из `ShefaAppBoot` (уже сделано).
 * Из перехватчиков: `setShefaLoaderProgress(pct)` или `ShefaLoader.setProgress(pct)`.
 */

let handler = null;

/**
 * @param {number} pct
 */
export function setShefaLoaderProgress(pct) {
  if (typeof pct !== 'number' || Number.isNaN(pct)) return;
  const v = Math.max(0, Math.min(100, pct));
  if (typeof handler === 'function') {
    try {
      handler(v);
    } catch {
      /* ignore */
    }
  }
}

/**
 * @param {(pct: number) => void} fn
 * @returns {() => void}
 */
export function registerShefaLoaderProgress(fn) {
  handler = fn;
  return () => {
    if (handler === fn) {
      handler = null;
    }
  };
}

export const ShefaLoader = {
  setProgress: setShefaLoaderProgress,
};
